<template>
    <div class="portrait">
        <div class="top-title" v-if="enterpriseFuncVersion">
            <div class="word">当前企业版本号：{{enterpriseFuncVersion}}</div>
            <div class="word" style="margin-left: 50px;">切换版本号: </div>
            <el-select v-model="enterpriseFuncVersion" placeholder="请选择" style="margin-left: 10px; width: 140px;" @change="selectChange">
                <el-option v-for="item in options" :key="item" :label="item" :value="item">
                </el-option>
            </el-select>
        </div>
        <div class="table_wrap" style="height: 400px;">
            <el-table ref="versionTable" stripe border style="width: 100%" height="100%" max-height="100%" :data="versionTable" v-loading="versionTableLoading">
                <el-table-column type="index"></el-table-column>
                <el-table-column property="pcVersion" label="版本号" width="80"></el-table-column>
                <el-table-column property="excludeMenuStr" label="废弃的功能" min-width="150"></el-table-column>
                <el-table-column property="addMenuStr" label="新增功能" min-width="150"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        versionPropData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            versionTableLoading: false,
            versionTable: [],
            enterpriseFuncVersion: '',
            oldEnterpriseFuncVersion: '',
            options: []
        };
    },
    created() {
        this.getVersion();
        this.getVersionList();
    },
    methods: {
        async getVersion() {
            let { enterpriseCode } = this.versionPropData;
            const { data: res } = await this.$post(
                "/erpnew/account/c/reada46ceb/plugin/selectFunVersionForMonitor", { enterpriseCode }
            );
            if (res.code == 0) {
                this.enterpriseFuncVersion = res.data.enterpriseFuncVersion
                this.oldEnterpriseFuncVersion = res.data.enterpriseFuncVersion
                this.options = res.data.enterpriseFuncVersions
            }
        },
        async getVersionList() {
            this.versionTableLoading = true;
            const { data: res } = await this.$post(
                "/erpnew/account/c/reada46ceb/plugin/selectMonitorFunVersion", {}
            );
            this.versionTableLoading = false;
            if (res.code == 0) {
                this.versionTable = res.data.map(item => {
                    let arr1 = []
                    let arr2 = []
                    item.addMenu.forEach(it => {
                        arr1.push(it.menudesc)
                    })
                    item.excludeMenu.forEach(it => {
                        arr2.push(it.menudesc)
                    })
                    item.addMenuStr = arr1.join(',')
                    item.excludeMenuStr = arr2.join(',')
                    return item
                })
            }
        },
        async selectChange(e) {
            console.log(e, this.oldEnterpriseFuncVersion)
            const confirmResult = await this.$confirm('确定要切换到此版本么?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return this.enterpriseFuncVersion = this.oldEnterpriseFuncVersion
            let obj = {
                enterpriseCode: this.versionPropData.enterpriseCode,
                enterpriseFuncVersion: e
            }
            this.versionTableLoading = true;
            const { data: res } = await this.$post(
                "/erpnew/account/c/reada46ceb/plugin/updateFunVersionForMonitor", obj
            );
            this.versionTableLoading = false;
            if (res.code == 0) {
                this.getVersion();
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
            } else {
                this.enterpriseFuncVersion = this.oldEnterpriseFuncVersion
                if (res.message) {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            }
        }
    },
}
</script>
<style lang="less">
.top-title {
    margin: 6px 0 12px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .word {
        font-size: 16px;
        color: #333333;
        font-weight: 700;
    }
}
</style>